import { makeStyles } from '@material-ui/core/styles';
import { flexAlignCenterJustifyCenter } from 'UI/utils/styles';

const MIN_HEIGHT = 260;

export const useStyles = makeStyles(
  theme => ({
    headerAction: {
      '& .MuiCardHeader-action': {
        display: 'flex',
        alignItems: 'center',
        margin: 'auto'
      }
    },
    cardContent: {
      padding: `${theme.spacing(3, 0)} !important`
    },
    cardContentWithMinHeight: {
      minHeight: MIN_HEIGHT
    },
    cardPaddingBottom: {
      padding: `${theme.spacing(0, 0, 3)} !important`
    },
    loading: {
      ...flexAlignCenterJustifyCenter
    },
    noPadding: {
      padding: '0 !important'
    }
  }),
  { name: 'MuiCardContent' }
);
